module.exports = {
	"slides": [
		{
			"fin": {
				"title": "Pascal",
				"description": "Firmamme viinitarhuri, jonka vastuulla on köynnösten hoito ympäri vuoden. Pascal on varsinainen ikiliikkuja, hän pysyy harvoin paikallaan."
			},
			"eng": {
				"title": "Pascal",
				"description": "Our vineyard manager who is responsible for the vineyard work all year long."
			},
			"photo": "pascal-taimitarhalla.jpg",
			"position": "70% 0%"
		},
		{
			"fin": {
				"title": "Nea",
				"description": "Viinintekijämme, joka vastaa nyt myös koko viinitilan jokapäiväisestä pyörittämisestä"
			},
			"eng": {
				"title": "Nea",
				"description": "Our winemaker, who is also responsible for the entire winery and its daily routines"
			},
			"photo": "nea-puun-alla.jpg",
			"position": "30% 0%"
		},
		{
			"fin": {
				"title": "Juha",
				"description": "“Le Patron”, joka on sadonkorjuussa myös osa-aikainen trukkikuskimme"
			},
			"eng": {
				"title": "Juha",
				"description": "“Le Patron” is our part-time forklift driver during harvest"
			},
			"photo": "pokku.jpg"
		},
		{
			"fin": {
				"title": "Nicole",
				"description": "Kaikkien rakastama kodin hengetär"
			},
			"eng": {
				"title": "Nicole",
				"description": "Our lovely Nicole takes care of the house and helps with everything we might need"
			},
			"photo": "nicole.jpg",
			"position": "30% 0%"
		},
		{
			"fin": {
				"title": "Soline",
				"description": "Jo yli 20 vuotta meillä työskennellyt supermimmi, joka pitää tarhat erinomaisessa kunnossa, johtaa sesonkityöntekijöitä tarhoilla ja auttaa Pascalia etiketöinnissä."
			},
			"eng": {
				"title": "Soline",
				"description": "Our full-time super girl who takes great care of the vineyards and manages seasonal workers but also helps Pascal with bottle stocks, packaging, etc."
			},
			"photo": "soline.jpg",
			"position": "70% 0%"
		},
		{
			"fin": {
				"title": "Sandrine",
				"description": "Osa-aikainen sihteerimme, joka pitää huolta tilauksista, toimituksista sekä hallinnosta"
			},
			"eng": {
				"title": "Sandrine",
				"description": "Our part-time secretary who keeps our books (and us) in order"
			},
			"photo": "sandrine.jpg",
			"position": "60% 0%"
		},
		{
			"fin": {
				"title": "Samuli",
				"description": "Viinitilan vakiokalustoksi luokiteltava sadonkorjaaja ja kellarikäsi"
			},
			"eng": {
				"title": "Samuli",
				"description": "Our loyal cellar hand is always coming up with new tricks and ideas"
			},
			"photo": "samppa-kaataa.jpg"
		},
		{
			"fin": {
				"title": "Kissat",
				"description": "Nean, Sampan ja kaikkien muiden suloiset silmäterät"
			},
			"eng": {
				"title": "Cats",
				"description": "The cellar cats"
			},
			"photo": "kissat.jpg",
			"position": "50% 30%"
		},
		{
			"fin": {
				"title": "Kanat",
				"description": "Nean luomukanat saavat tallustella tiluksilla vapaana."
			},
			"eng": {
				"title": "Chicks",
				"description": "Nea's chicken keep the vineyards well fertilised."
			},
			"photo": "kanat.jpg",
			"position": "70% 0%"
		},
		{
			"fin": {
				"title": "Hevoset",
				"description": "Comtois-työhevonen Philibert ja shetlanninponimme Bruno pitävät huolta ruohonleikkuusta tarhoilla, joilla ei kasva köynnöksiä"
			},
			"eng": {
				"title": "Horses",
				"description": "Our Comtois workhorse Philibert and shetland pony Bruno keep the lawns mowed on the parcels where we have no vines yet"
			},
			"photo": "ponit.jpg",
			"video": "ponit.mp4"
		},
		{
			"fin": {
				"description": "Merkittävää osaa palstoistamme on viljelty jo yli 20 vuotta ilman hyönteismyrkkyjä ja rikkaruohojen torjunta-aineita. Nyt kaikki palstat ovat luomua ja olemme luomusertifioituja."
			},
			"eng": {
				"description": "A major part of our vines have been cultivated without insecticides or pesticides for over 20 years. We are now officially certified organic."
			},
			"photo": "pascal-ja-kanat.jpg",
			"position": "15% 0%"
		},
		{
			"fin": {
				"description": "Tilamme on mainittu kaupunkimme Rionsin kirjoissa ensimmäisen kerran 1759. Tuolloin se oli Rionsin erään isoimman “linnan” torppa. Monet historioitsijat ovat kuitenkin kertoneet, että talomme paikalla on ollut asutusta jo roomalaisten ajoista lähtien."
			},
			"eng": {
				"description": "The first time Carsin was mentioned in the history books was in 1759. At the time, it was a croft of a bigger Chateau. Many historians have said that the Romans have lived on our lands."
			},
			"photo": "carsin-historia.jpg"
		},
		{
			"fin": {
				"title": "Talomme",
				"description": "150 vuotta vanha rakennus on Nean ja Samulin koti ja sadonkorjuuväen sympaattinen kortteeri."
			},
			"eng": {
				"title": "Our house",
				"description": "150 year-old building is Nea & Samuli’s home and also our harvest quarter."
			},
			"photo": "talo-sinisen-taivaan-alla.jpg",
			"position": "40% 0%"
		},
		{
			"fin": {
				"description": "Talvisaikaan Bordeaux'ssakin on pakkasta ja köynnökset vaipuvat horrostilaan."
			},
			"eng": {
				"description": "During winter it can be as cold as -10 Celsius in Bordeaux and the vines go dormant."
			},
			"photo": "talvi.jpg"
		},
		{
			"fin": {
				"title": "Talvileikkuu",
				"description": "Talven aikana Pascal leikkaa edellisen vuoden kasvun niin, että köynnökseen jää vain emo-oksa jäljelle. Emo-oksalla on silmuja, joista kustakin kasvaa uusi oksa. Oksille taas muodostuu kaksi terttua. Näin silmujen määrän kautta määrittelemme sadon määrän."
			},
			"eng": {
				"title": "Winter pruning",
				"description": "During the winter, Pascal prunes all the vines, leaving only the desired number of buds on the vine. As a bud bursts, it will become a branch and have 2 bunches on it. This is how we can manage the desired yield."
			},
			"photo": "pruning.jpg",
			"video": "pruning.mp4"
		},
		{
			"fin": {
				"title": "Oksien poisto",
				"description": "Edellisvuoden leikatut oksat vedetään pois tukilangoilta"
			},
			"eng": {
				"title": "Removing the old shoots",
				"description": "The old shoots are removed by hand after pruning"
			},
			"photo": "tirebois.jpg"
		},
		{
			"fin": {
				"title": "Takaisin maaperään",
				"description": "Oksat ajetaan traktorilla hakkelukseksi ja ne maatuvat takaisin riviväleihin"
			},
			"eng": {
				"title": "Decomposing",
				"description": "The removed shoots are shred with the tractor and the pieces will decompose back to the soil"
			},
			"photo": "branches.jpg"
		},
		{
			"fin": {
				"title": "Tukevasti langoilla",
				"description": "Emo-oksat sidotaan vielä tukilankoihin, jotta silmujen auetessa köynnöksellä on optimaalinen asento kasvua varten"
			},
			"eng": {
				"title": "Tied to the cords",
				"description": "The branches are tied to the wires so that when the buds burst, the position is optimal for growth"
			},
			"photo": "pikkusilmu.jpg"
		},
		{
			"fin": {
				"title": "Silmu aukeaa",
				"description": "Tässä näemme 6 viikon ajalta kuvatun videon köynnöksen valtavasta kasvuvauhdista"
			},
			"eng": {
				"title": "Bud burst",
				"description": "Here we can see the speed of the vine growth as the video has been filmed in 6 weeks"
			},
			"photo": "silmu.jpg",
			"video": "Carsin-spring-FINAL.mp4"
		},
		{
			"fin": {
				"description": "Soline kiertää sesonkityöntekijöiden kanssa kesän aikana tarhat moneen kertaan. He mm. poistavat ylimääräiset silmut sekä versot keväällä ja poistavat myöhemmin kesällä ylimääräiset tertut. Tavoitteenamme on, että kukin terttu on irrallaan toisista, jotta korjuun lähestyessä mahdollinen kosteus ei pääse muodostamaan hometta."
			},
			"eng": {
				"description": "Soline and seasonal workers go through our parcels many times during the year. They remove unwanted buds, branches, leaves and bunches. Our aim is to keep all the grape bunches apart from each other so that the autumn humidity cannot form any mold on our grapes before the harvest."
			},
			"photo": "soline-dylan.jpg",
			"position": "left"
		},
		{
			"fin": {
				"description": "Carsinin tiimillä on lähes 80.000 köynnöstä hoidettavanaan. Niille tehdään lähes viikottain joku operaatio – osittain kylläkin traktoreiden avustuksella. Tarhatyöt eivät helposti lopu kesken."
			},
			"eng": {
				"description": "Our team has almost 80,000 vines to take care of. Every week they work in the vineyards, often with the help of a tractor."
			},
			"photo": "koynnokset-ja-pilvet.jpg",
			"video": "taimitarha-tuulessa.mp4"
		},
		{
			"fin": {
				"title": "Istuttaminen",
				"description": "Uusien taimien istuttaminen käy helposti traktorilla, jota ohjailee gps-ohjelma, edes kuljettajaa ei tarvita. Pienet tukikepit ja kasvit sen sijaan pitää käsin laittaa paikoilleen ja kone hoitaa loput"
			},
			"eng": {
				"title": "Planting",
				"description": "Planting is easy with a tractor that has a gps program, we don't even need a driver. Small posts and the plants need to be put in their place and the machine takes care of the rest"
			},
			"photo": "planting.jpg",
			"video": "planting.mp4"
		},
		{
			"fin": {
				"description": "Muutamassa viikossa taimien silmut puhkeavat ja niihin muodostuu pienet lehdet"
			},
			"eng": {
				"description": "In a few weeks, the leaves come out and the plants start growing fast."
			},
			"photo": "pikkutaimet.jpg"
		},
		{
			"photo": "tolppakeppien-kuuppien-kaivuu.jpg",
			"video": "tukipuille-kolot.mp4",
			"position": "70% 0%"
		},
		{
			"fin": {
				"description": "Varsinkin nuorten taimien ympäriltä poistetaan rikkaruohot kuokilla, jotta niiden hoito olisi helpompaa ja ne pääsevät kasvamaan hyvin."
			},
			"eng": {
				"description": "We remove all the weeds around young vines so that they have less competition and a better chance to grow."
			},
			"photo": "jarski-kuokkimassa.jpg",
			"video": "kuokkimista.mp4"
		},
		{
			"fin": {
				"title": "Viinitarhat",
				"description": "Tarhojemme pinta-ala on noin 18 hehtaaria. Tästä punaisten osuus on noin 12 hehtaaria ja valkoisten 6 hehtaaria."
			},
			"eng": {
				"title": "The vineyards",
				"description": "We have about 18 hectares of vines; about 12 hectares of red and 6 hectares of white grape varieties."
			},
			"photo": "antti-taimitarhalla.jpg",
			"position": "30% 0%"
		},
		{
			"fin": {
				"title": "Rypälelajikkeet",
				"description": "Meillä on kolme valkoista rypälelajiketta: sauvignon gris, sauvignon blanc sekä sémillon"
			},
			"eng": {
				"title": "Grape varieties",
				"description": "We have 3 white varieties: Sauvignon Gris, Sauvignon Blanc and Sémillon."
			},
			"photo": "sauvignonblanc.jpg"
		},
		{
			"fin": {
				"title": "Rypälelajikkeet",
				"description": "Punaviinitarhojamme dominoi merlot, joka soveltuu saviseen ja hiekkaiseen maaperään. Muita lajikkeita ovat cabernet franc, cabernet sauvignon, malbec, carmenere sekä petit verdot."
			},
			"eng": {
				"title": "Grape varieties",
				"description": "Our red parcels are dominated by Merlot, which is well suited for our clay and sandy soils. Other varieties are Cabernet Franc, Cabernet Sauvignon, Malbec, Carmenere and Petit Verdot."
			},
			"photo": "punaiset-kypsyy-2.jpg",
			"position": "60% 0%"
		},
		{
			"fin": {
				"title": "Kellari",
				"description": "Kellarimme on rakennettu 1990-luvun alussa ja sieltä löytyvät viinitankit sekä rypäleiden vastaanotto."
			},
			"eng": {
				"title": "The cellar",
				"description": "Our cellar was built in early 1990’s. It houses all the tanks and the reception hall."
			},
			"photo": "kellarirakennus.jpg"
		},
		{
			"fin": {
				"description": "Viinitankit ovat terästä, joka on helppo pitää puhtaana ja siksi kiitollinen materiaali. Eri palstojen punaviinirypäleet rangataan, murskataan ja siirretään näihin tankkeihin käymisen ajaksi."
			},
			"eng": {
				"description": "Our tanks are made of stainless steel and are very easy to keep clean. Different lots of red wines will be destemmed, crushed and moved into these tanks for alcoholic fermentation."
			},
			"photo": "punaiset-tankit.jpg",
			"position": "0% 60%"
		},
		{
			"fin": {
				"title": "PIGit",
				"description": "Pienemmät fermentit ja koe-erät käyvät avonaisissa pienemmissä terästankeissa."
			},
			"eng": {
				"title": "PIGs",
				"description": "These little open-top tanks are called “Pigs” because we do a “pigeage” (punch downs) for the red wine that is in them."
			},
			"photo": "pigit.jpg",
			"position": "40% 0%"
		},
		{
			"fin": {
				"title": "Tynnyrit",
				"description": "Osa valkoviineistämme käyvät ja kypsyvät tammitynnyreissä noin 8 kuukautta ennen pullotusta."
			},
			"eng": {
				"title": "Barrels",
				"description": "Part of our white wines ferment and mature in oak barrels for about 8 months before bottling."
			},
			"photo": "valkoiset-tynnyrit.jpg",
			"position": "0% 60%"
		},
		{
			"fin": {
				"description": "Tynnyrikellarissa on n. 150 tynnyriä. Osa punaviineistä kypsytetään tynnyreissä, jolloin viinit imevät monenlaisia aromeja, kuten makeaa mausteisuutta, savua ja paahteisia piirteitä. Tynnyreissä viini myös saa hitaasti happea ja sen kypsymisominaisuudet paranevat."
			},
			"eng": {
				"description": "We have about 150 barrels in our barrel cellar. Most of our red wines get to mature in barrels for several months. They absorb different aromas such as sweet spiciness as well as smoky and toasty aromas. In the barrels, the wines also get a little bit of air and their ageing potential increases."
			},
			"photo": "tynnyrikellarissa.jpg"
		},
		{
			"fin": {
				"title": "Amforat",
				"description": "Uusin kokeilumme kellarissa on saviset amforat, jotka on ostettu Italiasta."
			},
			"eng": {
				"title": "Amphoras",
				"description": "Our new additions in the cellar are clay amphoras that have been bought from Italy. "
			},
			"photo": "amforat-2.jpg"
		},
		{
			"fin": {
				"description": "Sadonkorjuun lähestyessä riivimme terttujen ympäriltä lehdet, jotta ilma pääsee kiertämään. Näin ehkäisemme hometta aiheuttavaa kosteutta. Lähellä poimintaa poistamme myös auringon puolelta lehdet, jotta rypäleet saisivat kylpeä auringossa ja kypsyä tehokkaammin."
			},
			"eng": {
				"description": "Before the harvest, we remove leaves around the bunches to improve aeration around the grapes. This way we minimize the risk of mold hitting our grapes and ensure they have enough sunlight to mature."
			},
			"photo": "riipiminen.jpg"
		},
		{
			"fin": {
				"title": "Veraison & green harvest",
				"description": "Veraisoniksi kutsutaan sitä vaihetta kun rypäleiden väri muuttuu. Samaan aikaan joiltakin palstoiltamme vielä poistamme ylimääräisiä terttuja ja varmistamme köynnökseen jäävien terttujen parhaan mahdollisen laadun."
			},
			"eng": {
				"title": "Veraison & green harvest",
				"description": "Veraison is the moment when the colour of the grapes change. During this time, we also remove unwanted bunches in some of our red parcels. This is how we ensure the best possible quality of grapes."
			},
			"photo": "green.jpg",
			"position": "30% 0%"
		},
		{
			"fin": {
				"description": "Palstojen kypsymistä seurataan vähintäänkin viikottain otettavilla näytteillä."
			},
			"eng": {
				"description": "We follow the maturing process of the vineyards at least once a week."
			},
			"photo": "punaiset-kypsyy-3.jpg",
			"position": "60% 0%"
		},
		{
			"fin": {
				"description": "Näytteet otetaan tasaisesti palstojen eri puolilta – sekä auringon että varjon puolelta, jotta saisimme hyvän käsityksen rypäleiden kypsyydestä."
			},
			"eng": {
				"description": "The samples are taken from different parts of the parcel – from both the sunny and shady sides. This gives us a realistic and comprehensive sample."
			},
			"photo": "kypsien-rypskyjen-tutkailua.jpg",
			"position": "40% 0%"
		},
		{
			"fin": {
				"description": "Omassa laboratoriossamme näytteet puristetaan mehuksi. Mehusta mitataan sokeripitoisuus, hapot sekä pH. Tärkeää on myös huomioida mehujen aromit – miltä rypäleet maistuvat."
			},
			"eng": {
				"description": "In our laboratory, the samples are pressed into juice. We analyse the sugar content, acidity and pH. It’s also important to taste the juices and make notes on the aromas."
			},
			"photo": "naytteet.jpg"
		},
		{
			"fin": {
				"description": "Punaisten rypäleiden rangat ja siemenet muuttuvat tummiksi, kun ne alkavat olla valmiita. Kuoret puolestaan luovuttavat enemmän väriä ja siemenissä olevat karheat parkkihapot pehmenevät."
			},
			"eng": {
				"description": "The stems and pips turn brown when the grapes are ripe. The skin of the grapes gives up more colour and the tough tannins soften."
			},
			"photo": "kypsia-siemenia.jpg",
			"position": "70% 0%"
		},
		{
			"video": "jb-ottamaan-naytteita.mp4",
			"photo": "refraktromeetteri.jpg"
		},
		{
			"video": "jb-kayttaa-refraktromeetteria.mp4",
			"photo": "jb-tutkii-refraktromeetteria.jpg"
		},
		{
			"fin": {
				"description": "Refraktromittarin prisma taittaa valoa ja tämän avulla voidaan nopeasti määritellä rypäleiden sokeripitoisuus. Sokeri kertoo rypäleiden fysiologisesta kypsymisestä."
			},
			"eng": {
				"description": "The refractometer tells us how much sugar is in the grapes and how far we are in the ripening process."
			},
			"photo": "viewfinder.jpg"
		},
		{
			"fin": {
				"description": "Nuoret taimet kypsyvät yleensä ennen vanhempia köynnöksiä – niistä saadaan kuitenkin kevyempää ja nopeammin kypsyvää viiniä."
			},
			"eng": {
				"description": "Young vines tend to ripen faster than old ones. They produce lighter wines and are very good ingredients for our Rosé wine."
			},
			"photo": "nuoret-koynnokset.jpg"
		},
		{
			"fin": {
				"description": "Joitakin lajikkeita, kuten Petit Verdot’ia tulee tarkkailla loppuvaiheessa päivittäin, sillä homeet saattavat iskeä yllättävästi"
			},
			"eng": {
				"description": "Some parcels, such as Petit Verdot, need to be checked daily because mold can hit the most fragile vines overnight."
			},
			"photo": "jb-tutkimaan-kypsyytta.jpg",
			"position": "20% 0%"
		},
		{
			"fin": {
				"description": "Kukin vuosi on erilainen kuin edellinen. Aina on paljon uutta opittavaa ja erilaisia tilanteita. Vaikeissa oloissa sitten taidot mitataan."
			},
			"eng": {
				"description": "Every year is different. There are always new things to learn and we have to adjust to different situations. Our true skills are measured during difficult years."
			},
			"photo": "rankkasade-talon-edessa.jpg",
			"position": "60% 0%"
		},
		{
			"fin": {
				"description": "Meille saapuu noin 20 suomalaista vapaaehtoista vuosittain auttamaan rypäleiden poiminnassa ja muissa sadonkorjuutehtävissä."
			},
			"eng": {
				"description": "Every year, we welcome 20 Finnish volunteers to help us with grape-picking and other harvest activities."
			},
			"photo": "orjat.jpg"
		},
		{
			"fin": {
				"description": "Keittiö ja kokit ovat tärkeässä roolissa. Syksyisin saapuu viikottain Suomen eturivin kokkeja pitämään talkoolaiset kylläisinä."
			},
			"eng": {
				"description": "The kitchen is the heart of our house. During every harvest, we have some of the best chefs in Finland come in weekly to keep us well fed."
			},
			"photo": "kokki-maistaa.jpg"
		},
		{
			"photo": "faux-fillet.jpg"
		},
		{
			"fin": {
				"description": "Vasikan file oksilla grillattuna on monelle tuttu herkku."
			},
			"eng": {
				"description": "Veal fillet grilled on the vines is one of our favourites."
			},
			"photo": "vasikka.jpg"
		},
		{
			"fin": {
				"description": "Carsinin tomaatteja ei mikään voita, jotkut jopa vievät niitä Suomeen mukanaan."
			},
			"eng": {
				"description": "Nothing can compare to Carsin's tomatoes. Some of our friends even take them back home as a souvenir."
			},
			"photo": "pascalin-tomaatit.jpg",
			"position": "60% 0%"
		},
		{
			"fin": {
				"description": "Eri lajikkeet myös kypsyvät eri aikaan, joten poiminta jakaantuu lähes kahden kuukauden ajalle."
			},
			"eng": {
				"description": "Different grape varieties mature at different times, so we need helping hands for a period of two months."
			},
			"photo": "ryhmakuva2017.jpg"
		},
		{
			"fin": {
				"description": "Aloitamme valkoisten lajikkeiden poiminnalla. Sitten poimimme merlot- ja malbec-köynnökset. Myöhemmin kypsyvät cabernet’it, petit verdot sekä carmenere."
			},
			"eng": {
				"description": "We start with white parcels, then we continue with Merlot and Malbec. The Cabernets, Petit Verdot and Carmenere are the last ones to ripen."
			},
			"photo": "poiminta-alkaa.jpg"
		},
		{
			"fin": {
				"description": "Poimimme mahdollisuuksien mukaan kaikki rypäleet käsin."
			},
			"eng": {
				"description": "We try to pick everything by hand."
			},
			"photo": "punaisten-poimintaa.jpg",
			"video": "punaisten-poiminta-2.mp4"
		},
		{
			"fin": {
				"description": "Laatikot jaellaan aamulla tarhoille, jotta työ kävisi joutuisasti"
			},
			"eng": {
				"description": "The red picking baskets are distributed in the vineyards."
			},
			"photo": "pascalkori1.jpg",
			"position": "40% 0%"
		},
		{
			"photo": "pascalkori2.jpg"
		},
		{
			"fin": {
				"description": "Ammattilaisilta työ käy nopeasti."
			},
			"eng": {
				"description": "Professional pickers are very quick."
			},
			"photo": "antti-lootakarryssa.jpg",
			"video": "martine-poimii.mp4",
			"position": "60% 0%"
		},
		{
			"photo": "martine.jpg"
		},
		{
			"fin": {
				"description": "Vesihuolto tarhalla on tärkeää."
			},
			"eng": {
				"description": "Keeping ourselves hydrated is important in the vineyards."
			},
			"photo": "vesipullo-tarhalla.jpg",
			"position": "60% 0%"
		},
		{
			"fin": {
				"description": "Laatikot kerätään traktorin peräkärryille – Antilla ja Jarilla hymy ei hyydy töissäkään."
			},
			"eng": {
				"description": "The red baskets are lifted into the trailer. Even while working, Antti and Jari can’t stop smiling."
			},
			"photo": "kamelit-on-vahvoja.jpg",
			"position": "30% 0%"
		},
		{
			"fin": {
				"description": "Tarhoilta rypälelavat tuodaan vastaanottokellariin."
			},
			"eng": {
				"description": "From the vineyards, the grapes are brought into the reception hall."
			},
			"photo": "laatikoissa-rypaleita.jpg",
			"position": "40% 0%"
		},
		{
			"fin": {
				"description": "Myös pienet stiplut kuuluvat sadonkorjuuseen"
			},
			"eng": {
				"description": "Little mistakes are also part of harvest"
			},
			"photo": "oops.jpg"
		},
		{
			"fin": {
				"title": "Puristin",
				"description": "Pneumaattisen tankkipuristimemme kapasiteetti on 5000 litraa. Parhaimmillaan noin kolmen tunnin puristinprosessin aikana paineet nousevat noin 2000 millibariin, joka on suunnilleen saman verran kuin autojen renkaiden paineet."
			},
			"eng": {
				"title": "The press",
				"description": "Our pneumatic press can handle 5000 litres of grapes. At its peak, the pressure rises to 2000mba, which is about the same as in a car tire."
			},
			"photo": "puristin.jpg",
			"position": "left"
		},
		{
			"fin": {
				"title": "Laatikoiden pesu",
				"description": "Pesemme keräilylaatikot päivittäin tyhjennyksen jälkeen savesta ja rypälemehusta. Puhtaus on äärimmäisen tärkeää, vaikka työ onkin yksitoikkoista…"
			},
			"eng": {
				"title": "Washing the baskets",
				"description": "We wash our picking baskets every day. Cleanliness is very important to us, though the work might be a bit boring…"
			},
			"photo": "juhani.jpg"
		},
		{
			"fin": {
				"description": "Sadonkorjuu on rankkaa työtä, mutta hymyllä jaksaa pitkälle."
			},
			"eng": {
				"description": "Harvest is tough work and long hours, but smile goes a long way."
			},
			"photo": "pia.jpg"
		},
		{
			"fin": {
				"description": "Punaiset lähetetään aluksi rankaimeen ja sieltä eteenpäin sortteerauspöydän kautta tankkiin."
			},
			"eng": {
				"description": "The red grapes are destemmed and sorted before they are put into the fermentation tank."
			},
			"video": "hihnalta-rankaimen-kautta-poydalle.mp4",
			"photo": "laatikoista-hihnalle.jpg"
		},
		{
			"fin": {
				"description": "Rankaaja erottelee rypäleet rangoista, jonka jälkeen rypäleet vielä tarkastetaan ennen murskausta."
			},
			"eng": {
				"description": "The destemmer removes the stems, after which we sort the grapes on the table."
			},
			"photo": "rankain-sortteerauksessa.jpg",
			"video": "rankausta-kellarissa.mp4"
		},
		{
			"fin": {
				"description": "Sortteerauspöydällä pyritään poistamaan kaikki vihreä aines; lehdet, ranganpalaset yms., jotta punaviineistämme tulisi mahdollisimman puhtaita ja meheviä."
			},
			"eng": {
				"description": "At the sorting table, we remove all green particles: leaves, pieces of stems, unripe berries etc. This is how we ensure the purity of the wines."
			},
			"video": "sortteerausta.mp4",
			"photo": "sortteerausta.jpg"
		},
		{
			"photo": "respa.jpg"
		},
		{
			"fin": {
				"title": "Tankkitaulu",
				"description": "Kustakin poimintaerästä pidetään tarkasti kirjaa. Tankkitaulu kertoo missä mikäkin viinierä kellarissa sijaitsee."
			},
			"eng": {
				"title": "Tank capacity",
				"description": "It’s important to keep the traceability of the wines in order. Using the board we can see which lot of wine is in which tank."
			},
			"photo": "tankkitaulu.jpg"
		},
		{
			"fin": {
				"description": "Punaviinejä tavoittelemme noin 4500 litraa hehtaarilta, valkoisia hieman enemmän. On muistettava minkälainen loppu ahneilla yleensä on…"
			},
			"eng": {
				"description": "From red parcels, we try to make 4500 litres per hectare and a little bit more from the whites."
			},
			"photo": "tyon-tohinassa.jpg",
			"video": "nopeutettu-poiminta.mp4"
		},
		{
			"fin": {
				"description": "Upeat kokkimme loihtivat mahtavat kotilounaat talkooporukalle ja ruoka todella maistuu rankan poimintapäivän jälkeen."
			},
			"eng": {
				"description": "Our excellent chefs keep us well fed. The food truly tastes good after a long morning in the vineyards."
			},
			"photo": "lounas-terassilla.jpg"
		},
		{
			"fin": {
				"description": "Aamulla joukkomme poimii palstoilla, iltapäivällä prosessoidaan punaiset poimitut rypäleet kellarissa ja viimeisenä siivotaan aikaansaatu sotku. Vuosittain käsittelemme noin 100 tuhatta kiloa rypäleitä."
			},
			"eng": {
				"description": "In the morning, we pick grapes and in the afternoon we process them. The last part of the day is cleaning up. Every year we process about 100 000 kilograms of grapes."
			},
			"photo": "rypaleiset-kadet.jpg",
			"position": "55% 0%"
		},
		{
			"fin": {
				"description": "Saksetkin pitää pestä huolella."
			},
			"eng": {
				"description": "The scissors need to be well washed as well."
			},
			"photo": "saksien-pesu.jpg",
			"position": "0% 90%"
		},
		{
			"fin": {
				"description": "Ansaittu huikka työpäivän päätteeksi."
			},
			"eng": {
				"description": "A well-deserved beer after a long day at work."
			},
			"photo": "jarski-oluella-toiden-jalkeen.jpg"
		},
		{
			"fin": {
				"description": "Ilman olutta ei synny viiniä."
			},
			"eng": {
				"description": "It takes a lot of beer to make wine."
			},
			"photo": "olut-toiden-jalkeen.jpg",
			"position": "55% 0%"
		},
		{
			"fin": {
				"description": "Illalliset terassilla ovat huumaavia, kun sirkat sirittävät ja tähdet syttyvät taivaalle."
			},
			"eng": {
				"description": "The dinners on the terrace are amazing experiences as the stars are above us."
			},
			"photo": "illallinen-alkamassa-terassilla.jpg",
			"position": "60% 0%"
		},
		{
			"photo": "illallinen-ulkona.jpg",
			"position": "65% 0%"
		},
		{
			"fin": {
				"description": "Ruska tulee nopeasti sadonkorjuun jälkeen, kun ilmat kylmenevät loka-marraskuussa."
			},
			"eng": {
				"description": "The colours change quickly after the harvest as the weather gets colder in October and November."
			},
			"photo": "punalehtiset-carmeneret.jpg"
		},
		{
			"fin": {
				"description": "Garonne-joen nousuveden mukana syntyvä usva luo parhaat olosuhteet jalohomeen syntymiselle makeaa viiniä varten poimittavilla Semillon –tarhoilla."
			},
			"eng": {
				"description": "The river Garonne brings in the mist, which creates ideal conditions for the noble rot, botrytis cinerea, in the Semillon parcels."
			},
			"photo": "laakson-sumu.jpg"
		},
		{
			"fin": {
				"description": "Kun kypsät valkoiset rypäleet homehtuvat, haurastuu niiden kuori. Kuumuus ja aurinko haihduttavat tämän johdosta merkittävän osan rypäleen nesteestä pois. Sokerit ja hapot tiivistyvät ja aromimaailma muuttuu. Näin syntyvät jalohomeen rusinoimat makeat viinit."
			},
			"eng": {
				"title": "Botrytised grapes",
				"description": "As the botrytis hits the mature white grapes, the heat and sun concentrate the sugar and acid content of the grapes and changes the aroma profile of the juice. This is how the noble rotted sweet wines get their characteristics."
			},
			"photo": "jalohomeiset-rypaleet.jpg"
		},
		{
			"fin": {
				"description": "Makeat rypäleet poimitaan loka-marraskuun vaihteessa ja laatikoiden sijaan käytämme ämpäreitä, joista kippaamme homeiset rypäleet traktorin umpinaiseen peräkärryyn"
			},
			"eng": {
				"description": "The sweet grapes are picked in late October or early November and instead of baskets we use buckets from where the grapes are put into the trailer behind the tractor"
			},
			"photo": "sweetpick.jpg",
			"video": "sweetpick.mp4"
		},
		{
			"fin": {
				"description": "Viinitynnyreiden käymistä tarkkaillaan päivittäin ottamalla kaikista tynnyreistä näytteet."
			},
			"eng": {
				"description": "The fermentation process is monitored carefully every day."
			},
			"photo": "naytteet-tynnyreista.jpg",
			"video": "naytteiden-ottoa-tynnyreista.mp4"
		},
		{
			"fin": {
				"description": "Ominaispainomittari kertoo uuteainepitoisuuden mehussa ja käyvässä viinissä – eli käytännössä mehun sokeripitoisuuden"
			},
			"eng": {
				"description": "The specific gravity meter tells us the sugar content of the juices."
			},
			"photo": "ominaispainomittari-mehussa.jpg",
			"video": "ominaispainomittari-kertoo-sokerin.mp4"
		},
		{
			"fin": {
				"description": "Punaviinin käydessä kuoret nousevat pintaan. Niistä pyritään kuitenkin liuottamaan sekä väriä että tanniineja ja aromeja, joten ne on pidettävä kosteina. Bordeaux’ssa tapana on kostuttaa rypälemassa pumppaamalla käyvä viini tankin alaosasta letkulla rypäleiden päälle. Tätä kutsutaan “remontage” tai englantilaisittain “pump over”."
			},
			"eng": {
				"description": "As the red wines ferment, the grapes rise to the top of the tank. We extract colour, tannins and aromas by pumping the juice from the bottom of the tank over the top."
			},
			"photo": "pumpover-ylhaalta.jpg",
			"video": "pumpover-ylhaalta.mp4"
		},
		{
			"photo": "joonapump.jpg"
		},
		{
			"fin": {
				"description": "Hienovaraisempi tapa kostuttaa rypäleet on painaa ne tankin syvyyksiin – tämä on ranskalaiselta nimeltään “pigeage”"
			},
			"eng": {
				"description": "A more gentle way of moisturizing the grapes is to push them down. This is called “pigeage” in French."
			},
			"photo": "tynnyri-pigeage.jpg",
			"video": "pigeage-pig.mp4"
		},
		{
			"fin": {
				"description": "Harvemmin enää poljetaan rypäleitä, mutta ei se nyt ihan tavatonta ole…"
			},
			"eng": {
				"description": "Nowadays, we don’t use our feet to crush the grapes, but it’s not a completely extinct tradition."
			},
			"photo": "jalat-tynnyrissa.jpg",
			"position": "65% 0%"
		},
		{
			"fin": {
				"title": "Batonnage",
				"description": "Valkoviinien käymisen loppuvaiheessa ja sen loputtua hiivasakkoja pyöritellään tynnyrissä, jotta saadaan käyminen maaliin ja mm. suojataan viiniä hapettumiselta pitämällä se sameana. Ranskalaisittain tämä vaihe on “batonnage”."
			},
			"eng": {
				"title": "Batonnage",
				"description": "We stir the lees at the bottom of the white wine barrels to help the wines finish their fermentation and keep them cloudy. The clearer the wine is, the more sensitive it is to oxidation."
			},
			"photo": "batonage.jpg",
			"position": "0% 30%"
		},
		{
			"fin": {
				"description": "Punaviinimäski puristetaan vasta käymisen jälkeen. Puristimen sisällä on iso ilmapallo, joka laajenee kompressorin pumpatessa siihen ilmaa. Saamme kilosta rypäleitä noin 6,5 – 7 dl viiniä tai mehua."
			},
			"eng": {
				"description": "The red wines are pressed after the alcoholic fermentation. There’s a big balloon in the press that expands. From one kilogram of grapes, we get about 6,5 – 7 dl of wine or juice."
			},
			"photo": "inside-red-tank.jpg"
		},
		{
			"fin": {
				"description": "Puristejäte toimitetaan tislaamoon jatkokäsittelyyn, missä siitä tehdään teollista alkoholia."
			},
			"eng": {
				"description": "The skins are sent to a distillery where they are used to make industrial alcohol."
			},
			"photo": "punainen-marc-puristimesta.jpg",
			"video": "marcin-poisto-pressista.mp4"
		},
		{
			"fin": {
				"description": "Puhtaus on viininvalmistuksessa ensisijaisen tärkeää ja käytämme siihen paljon aikaa. Kaikki pinnat, joita viini koskettaa, desinfioidaan ennen ja jälkeen käytön."
			},
			"eng": {
				"description": "Cleanliness is very important in winemaking and we use quite a bit of time for it. All surfaces that the wine touches are desinfected before and after the use."
			},
			"photo": "enni.jpg"
		},
		{
			"fin": {
				"description": "Kun viinit ovat valmiita pullotettaviksi, naapuruston Serge tuo rekkansa pihallemme ja pullottaa parhaimmillaan kymmeniä tuhansia pulloja päivässä."
			},
			"eng": {
				"description": "When the wines are ready for bottling, our neighbour, Serge, comes in with his truck and can bottle tens of thousands of bottles per day."
			},
			"photo": "serge.jpg"
		},
		{
			"fin": {
				"description": "Pienet erityiserät saatetaan pullottaa käsin, kuten kuohuviinikokeilut. Kuvassa Charivari Winesin Pét'Nat 2018 -viinin pullotustiimi"
			},
			"eng": {
				"description": "Small special lots might be bottled by hand. Here's a photo of our bottling team for Charivari Wines Pét'Nat 2018"
			},
			"photo": "petnat.jpg"
		},
		{
			"fin": {
				"description": "Pullot säilytetään 600 pullon laatikkolavoilla ennen etiketöintiä ja kuljetusta asiakkaille"
			},
			"eng": {
				"description": "The bottles are kept on pallets that can hold 600 bottles apiece."
			},
			"photo": "valkkaripulloja-pullotuksesta.jpg"
		},
		{
			"fin": {
				"title": "Kapselointi"
			},
			"eng": {
				"title": "Encapsulation"
			},
			"photo": "kapselointi.jpg",
			"video": "kapselointi.mp4"
		},
		{
			"fin": {
				"description": "Etiketöidyt pullot pakataan käsin laatikoihin ja lähetetään eteenpäin maailmalle."
			},
			"eng": {
				"description": "Labelled bottles are packed into cartons and shipped all over the world."
			},
			"photo": "etiketointikoneella-laatikkoihin.jpg",
			"video": "etiketoinnista-laatikkoon.mp4",
			"position": "60% 0%"
		},
		{
			"fin": {
				"description": "Vanha pinjapuu ja upeat auringonlaskut kuuluvat kaikkien orjien kuvasatoon."
			},
			"eng": {
				"description": "Our old pine tree and the amazing sunsets are the most photographed view at Carsin."
			},
			"photo": "vahvat-varit-illalla.jpg",
			"position": "70% 0%"
		},
		{
			"fin": {
				"description": "Sittemmin olemme omaksuneet enemmän tarhoille painottuvan viininvalmistusfilosofian. Nykyisin pyrimme antamaan kaikkien kukkien kukkia. Alkuperäisyys ja vanhan kansan opit ovat valttia."
			},
			"eng": {
				"description": "Since then, we have moved on. Our philosophy has changed towards make wines in the vineyards. Originality and authenticity are important to us, and without a good raw ingredient, you can’t make good wine."
			},
			"photo": "mandy-ballet.jpg"
		},
		{
			"fin": {
				"description": "Hugh Johnson listaa kirjassaan Carsinin yhdeksi henkilökohtaisista suosikeistaan tällä alueella. Myös maailmankuulu viinikirjailija Jancis Robinson mainitsee Carsinin omaksi suosikikseen."
			},
			"eng": {
				"description": "Hugh Johnson lists Carsin as one of his personal favorites of the area. World known wine writer Jancis Robinson also thinks of Carsin as one of her favourite producers in Bordeaux."
			},
			"photo": "hugh-johnson.jpg",
			"position": "60% 0%"
		},
		{
			"fin": {
				"description": "Isännän harrastuksena on myös balsamiviinietikan teko, jota varten on omat tilansa."
			},
			"eng": {
				"description": "Juha’s hobby is also balsamic vinegar, for which we have our own little place."
			},
			"photo": "balsamico-tynnyrit.jpg",
			"position": "10% 0%"
		},
		{
			"fin": {
				"description": "Viinintekijämme Nea kokeilee mielellään uusia juttuja. Kaikki kuohuviinikokeilut eivät ole aina onnistuneet täydellisesti."
			},
			"eng": {
				"description": "Our winemaker Nea experiments with plenty of things. All sparkling wine experiments have not succeeded perfectly though."
			},
			"photo": "petnat.jpg",
			"video": "nea-petnat.mp4"
		},
		{
			"fin": {
				"description": "Nea on luonut myös Carsinille alkuviinejä, Charivarin viinit ovat mahdollisimman luonnollisia, persoonallisia ja autenttisia viinejä."
			},
			"eng": {
				"description": "Nea has also created her own winebrand, Charivari Wines makes authentic wines that have plenty of character"
			},
			"photo": "charivari.jpg"
		},
		{
			"fin": {
				"description": "Säännöllisesti maistelemme tuotteitamme, sillä on tärkeää nähdä miten ne kehittyvät ja tarkkailla tuotteidemme laatua. Makeaa viiniä meillä on varastossa useita vuosikertoja."
			},
			"eng": {
				"description": "We taste our own products regularly to see how they develop in bottles. We have many vintages of sweet wine in our bottle stock."
			},
			"photo": "cadillac-tasting-keittiossa.jpg"
		},
		{
			"fin": {
				"description": "Nea huolehtii viininvalmistuksen lisäksi ruusuista. Ennen vanhaan ruusuja istuttettiin aina köynnösten läheisyyteen ja ne toimivat indikaattoreina mahdollisista ongelmista."
			},
			"eng": {
				"description": "Nea takes care of not only the vines, but all other plants as well. In the old days, roses were planted next to the vines and kept as an indicator of possible problems in the soil."
			},
			"photo": "ruusu.jpg",
			"position": "70% 0%"
		},
		{
			"photo": "terassi-yomyohaan.jpg",
			"position": "80% 0%"
		},
		{
			"fin": {
				"title": "Vierailut",
				"description": "Meillä käy paljon vierailijoita vuosittain, mukana myös mm. pappamopoilijoita Suomesta asti"
			},
			"eng": {
				"title": "Visits",
				"description": "We have plenty of visitors every year, such as the Pappa-Tunturi mopedists from Finland"
			},
			"photo": "pappaporukka.jpg"
		},
		{
			"fin": {
				"title": "Carsinin punaviinit"
			},
			"eng": {
				"title": "The red wines of Carsin"
			},
			"photo": "viinit.jpg",
			"position": "45% 0%"
		},
		{
			"fin": {
				"description": "Carsinin viinit ovat parhaimmillaan ruokapöydässä, hyvässä seurassa"
			},
			"eng": {
				"description": "Our wines are at their best when enjoyed with food and good company"
			},
			"photo": "cn.jpg"
		},
		{
			"fin": {
				"description": "Osallistumme vuosittain useisiin viini- ja ruokatapahtumiin, jossa aurinkoinen henkilökuntamme ottaa teidät aina ilolla vastaan"
			},
			"eng": {
				"description": "We do several wine and food events every year where our staff welcomes you to taste our wines."
			},
			"photo": "turku.jpg"
		},
		{
			"fin": {
				"title": "Kiitos, kun tutustuit Carsiniin",
				"description": "toivotamme sinulle mainioita hetkiä viinien parissa. - Nea & Juha Berglund"
			},
			"eng": {
				"title": "Thank you",
				"description": "we wish you great moments with our wines. - Nea & Juha Berglund"
			},
			"photo": "nea-ja-pokku.jpg"
		},
		{
			"fin": {
				"title": "Kuvat",
				"description": "Ville Saarinen, Stefan Bremer, Sami Piskonen, Onerva Utriainen, Lauri Olander & Nea Berglund"
			},
			"eng": {
				"title": "Photos",
				"description": "Ville Saarinen, Stefan Bremer, Sami Piskonen, Onerva Utriainen, Lauri Olander & Nea Berglund"
			},
			"photo": "salama-ilta-auringossa.jpg"
		}
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/content.json
 ** module id = 442
 ** module chunks = 0
 **/